import { useState } from 'react';
import { toast } from 'react-toastify';
import { Edit, Save, X, KeyRound, User, Phone, MapPin, Building2, Shield } from 'lucide-react';
import { Card, Button } from '@components/ui';
import clsx from 'clsx';

/**
 * Şantiye Şefi Profil Sayfası
 * Basitleştirilmiş versiyon - Şef yetkileri
 */
export default function SefProfil() {
    const [isEditing, setIsEditing] = useState(false);
    const [profile, setProfile] = useState({
        name: 'Serkan Yıldırım',
        email: 'serkan@insaet.com',
        phone: '0555 111 11 30',
        role: 'Şantiye Şefi',
        assignedSite: 'Yeşil Park Konutları',
        address: 'Bakırköy, İstanbul',
        emergencyContact: 'Ali Yıldırım - 0555 222 33 44',
    });

    const [formData, setFormData] = useState(profile);

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSave = () => {
        setProfile(formData);
        setIsEditing(false);
        toast.success('Profil bilgileriniz güncellendi');
    };

    const handleCancel = () => {
        setFormData(profile);
        setIsEditing(false);
    };

    const inputClass = "w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary text-text-primary focus:ring-2 focus:ring-primary focus:border-transparent";
    const labelClass = "block text-sm font-medium text-text-secondary mb-1";

    return (
        <div className="p-4 md:p-6 space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-bold text-text-primary">Profilim</h1>
                    <p className="text-text-tertiary mt-1">Kişisel bilgilerinizi görüntüleyin ve düzenleyin</p>
                </div>
                <div className="flex gap-2">
                    {isEditing ? (
                        <>
                            <Button variant="ghost" icon={<X size={18} />} onClick={handleCancel}>
                                İptal
                            </Button>
                            <Button variant="success" icon={<Save size={18} />} onClick={handleSave}>
                                Kaydet
                            </Button>
                        </>
                    ) : (
                        <Button variant="primary" icon={<Edit size={18} />} onClick={() => setIsEditing(true)}>
                            Düzenle
                        </Button>
                    )}
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Profil Kartı */}
                <Card padding="lg" className="text-center">
                    <div className="w-24 h-24 rounded-full bg-secondary/10 flex items-center justify-center mx-auto mb-4">
                        <span className="text-4xl font-bold text-secondary">
                            {profile.name.charAt(0)}
                        </span>
                    </div>
                    <h2 className="text-xl font-bold text-text-primary">{profile.name}</h2>
                    <p className="text-text-muted">{profile.role}</p>
                    <div className="mt-4 p-3 bg-secondary/10 rounded-lg">
                        <div className="flex items-center justify-center gap-2 text-secondary">
                            <Building2 size={18} />
                            <span className="font-medium">{profile.assignedSite}</span>
                        </div>
                    </div>

                    {/* Hızlı İşlemler */}
                    <div className="mt-6 pt-6 border-t border-border-light space-y-2">
                        <button className="w-full flex items-center gap-3 px-4 py-3 rounded-xl bg-bg-tertiary hover:bg-bg-hover text-text-secondary hover:text-text-primary transition-all text-left">
                            <KeyRound size={18} />
                            <span className="text-sm font-medium">Şifre Değiştir</span>
                        </button>
                    </div>
                </Card>

                {/* Bilgi Formu */}
                <Card padding="lg" className="lg:col-span-2">
                    <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center gap-2">
                        <User size={20} />
                        Kişisel Bilgiler
                    </h3>

                    {isEditing ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className={labelClass}>Ad Soyad</label>
                                <input
                                    type="text"
                                    className={inputClass}
                                    value={formData.name}
                                    onChange={(e) => handleChange('name', e.target.value)}
                                />
                            </div>
                            <div>
                                <label className={labelClass}>E-posta</label>
                                <input
                                    type="email"
                                    className={inputClass}
                                    value={formData.email}
                                    onChange={(e) => handleChange('email', e.target.value)}
                                />
                            </div>
                            <div>
                                <label className={labelClass}>Telefon</label>
                                <input
                                    type="tel"
                                    className={inputClass}
                                    value={formData.phone}
                                    onChange={(e) => handleChange('phone', e.target.value)}
                                />
                            </div>
                            <div>
                                <label className={labelClass}>Adres</label>
                                <input
                                    type="text"
                                    className={inputClass}
                                    value={formData.address}
                                    onChange={(e) => handleChange('address', e.target.value)}
                                />
                            </div>
                            <div className="md:col-span-2">
                                <label className={labelClass}>Acil Durum İletişim</label>
                                <input
                                    type="text"
                                    className={inputClass}
                                    value={formData.emergencyContact}
                                    onChange={(e) => handleChange('emergencyContact', e.target.value)}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <InfoItem icon={User} label="Ad Soyad" value={profile.name} />
                            <InfoItem icon={Phone} label="Telefon" value={profile.phone} />
                            <InfoItem icon={MapPin} label="E-posta" value={profile.email} />
                            <InfoItem icon={MapPin} label="Adres" value={profile.address} />
                            <InfoItem icon={Shield} label="Acil Durum" value={profile.emergencyContact} className="md:col-span-2" />
                        </div>
                    )}
                </Card>
            </div>
        </div>
    );
}

function InfoItem({ icon: Icon, label, value, className }) {
    return (
        <div className={clsx("flex items-center gap-3 p-3 bg-bg-tertiary rounded-lg", className)}>
            <div className="w-10 h-10 rounded-lg bg-bg-secondary flex items-center justify-center shrink-0">
                <Icon size={18} className="text-text-tertiary" />
            </div>
            <div className="min-w-0">
                <p className="text-xs text-text-muted">{label}</p>
                <p className="font-medium text-text-primary truncate">{value}</p>
            </div>
        </div>
    );
}
